import React, { useEffect } from 'react';
import { useMemberProfileApi } from '@apis/useMemberProfileApi';

const SET_MEMBER_PROFILE = 'SET_MEMBER_PROFILE';
const UPDATE_MEASURE_DAY = 'UPDATE_MEASURE_DAY';
const UPDATE_SMS_STATUS = 'UPDATE_SMS_STATUS';
const UPDATE_MARKETING_STATUS = 'UPDATE_MARKETING_STATUS';
const UPDATE_PROTEIN_PUSH = 'UPDATE_PROTEIN_PUSH';
const UPDATE_PROBIOTICS_PUSH = 'UPDATE_PROBIOTICS_PUSH';
const UPDATE_CALCIUM_PUSH = 'UPDATE_CALCIUM_PUSH';
const UPDATE_SMART_RING_PUSH = 'UPDATE_SMART_RING_PUSH';
const UPDATE_HUNDRED_T_SHIRT_SIZE = 'UPDATE_HUNDRED_T_SHIRT_SIZE';
const UPDATE_SPECIAL_CONDITION = 'UPDATE_SPECIAL_CONDITION';
const UPDATE_MEMO = 'UPDATE_MEMO';
const UPDATE_BATCH_PAYMENT_MEMO = 'UPDATE_BATCH_PAYMENT_MEMO';
const UPDATE_X_FACTOR_NOTES = 'UPDATE_X_FACTOR_NOTES';
const UPDATE_AGREED_NOTES = 'UPDATE_AGREED_NOTES';
const UPDATE_GUIDANCE_NOTES = 'UPDATE_GUIDANCE_NOTES';
const UPDATE_SPECIAL_BODY_CONDITION = 'UPDATE_SPECIAL_BODY_CONDITION';
const UPDATE_SERVICE_TASKS = 'UPDATE_SERVICE_TASKS';
const UPDATE_DISCARD_RECORD_REASON = 'UPDATE_DISCARD_RECORD_REASON';

const memberProfileReducer = (state, action) => {
    switch (action.type) {
        case SET_MEMBER_PROFILE:
            return action.payload;
        case UPDATE_MEASURE_DAY: // 更新量身日
            return {
                ...state,
                ...action.payload,
            };
        case UPDATE_SMS_STATUS: // 更新簡訊通知
            return {
                ...state,
                hasSMS: action.payload,
            };
        case UPDATE_MARKETING_STATUS: // 更新行銷設定
            return {
                ...state,
                hasMarketing: action.payload,
            };
        case UPDATE_PROTEIN_PUSH: // 更新蛋白推進
            return {
                ...state,
                proteinPush: {
                    ...state.proteinPush,
                    ...action.payload,
                },
            };
        case UPDATE_PROBIOTICS_PUSH: // 更新益菌推進
            return {
                ...state,
                probioticsPush: {
                    ...state.probioticsPush,
                    ...action.payload,
                },
            };
        case UPDATE_CALCIUM_PUSH: // 更新鈣推進
            return {
                ...state,
                calciumPush: {
                    ...state.calciumPush,
                    ...action.payload,
                },
            };
        case UPDATE_SMART_RING_PUSH: // 更新智能訂單推進
            return {
                ...state,
                smartRingPush: {
                    ...state.calciumPush,
                    ...action.payload,
                },
            };
        case UPDATE_HUNDRED_T_SHIRT_SIZE: // 更新百T尺寸
            return {
                ...state,
                hundredTShirtSize: action.payload,
            };
        case UPDATE_SPECIAL_CONDITION: // 更新聯繫注意與偏好
            return {
                ...state,
                specialCondition: action.payload,
            };
        case UPDATE_MEMO: // 更新備註
            return {
                ...state,
                memo: action.payload,
            };
        case UPDATE_BATCH_PAYMENT_MEMO: // 更新批次扣款備註
            return {
                ...state,
                batchPaymentMemo: action.payload,
            };
        case UPDATE_X_FACTOR_NOTES: // 更新X-Factor
            return {
                ...state,
                xFactorNotes: action.payload,
            };
        case UPDATE_AGREED_NOTES: // 更新約定事項
            return {
                ...state,
                agreedNotes: action.payload,
            };
        case UPDATE_GUIDANCE_NOTES: // 更新指導注意
            return {
                ...state,
                guidanceNotes: action.payload,
            };
        case UPDATE_SPECIAL_BODY_CONDITION: // 更新特殊身體狀況
            return {
                ...state,
                specialBodyCondition: action.payload,
            };
        case UPDATE_SERVICE_TASKS: // 更新待辦事項
            return {
                ...state,
                serviceTasks: action.payload,
            };
        case UPDATE_DISCARD_RECORD_REASON: // 更新停止接收通知原因
            return {
                ...state,
                discardRecordReason: action.payload,
            }
        default:
            return state;
    }
};

const useGetMemberProfileState = ({ isFetchOnMount = true, memberID } = {}) => {
    const { getMemberProfileApi } = useMemberProfileApi();
    const [state, dispatch] = React.useReducer(memberProfileReducer, {
        memberID: 0,
        clubID: 0,
        memberNo: '',
        memberName: '',
        nickName: '',
        picturePath: '',
        proPicturePath: null,
        memberCardNo: '',
        hasSMS: false, // 簡訊通知
        hasMarketing: false, // 行銷設定
        xFactorNotes: [], // X-Factor
        agreedNotes: [], // 約定事項
        guidanceNotes: '', // 指導注意
        specialCondition: '', // 聯繫注意與偏好
        memo: '', // 備註
        batchPaymentMemo: '', // 批次扣款備註
        membershipStatus: 1, // 會籍狀態
        measureDay: 1, // WM日
        isInterviewNotMeasure: false, //是否只面談不量身
        hundredTShirtSize: '', // 百T尺寸
        specialBodyCondition: '', // 特殊身體狀況
        healthDeclaration: '', // 健康申告書
        discardRecordReason: "", // 停止接收通知原因
        proteinPush: {
            // 蛋白推進
            pushStatus: 4,
            pushStatusText: '未訂購',
            reasonType: 0,
            reasonTypeText: '',
            reasonText: '',
            isEditable: true,
        },
        probioticsPush: {
            // 益菌推進
            pushStatus: 4,
            pushStatusText: '未訂購',
            reasonType: 0,
            reasonTypeText: '',
            reasonText: '',
            isEditable: true,
        },
        calciumPush: {
            // 鈣推進
            pushStatus: 4,
            pushStatusText: '未訂購',
            reasonType: 0,
            reasonTypeText: '',
            reasonText: '',
            isEditable: true,
        },
        smartRingPush: {
            // 智能訂單推進
            pushStatus: 4,
            pushStatusText: '未訂購',
            reasonType: 0,
            reasonTypeText: '',
            reasonText: '',
            isEditable: true,
        },
        serviceTasks: [], // 主要顯示待辦事項
        resource: {
            pushStatusOptions: [],
            pushReasonTypeOptions: [],
            hundredTShirtSizeTextOptions: [],
            serviceTodoTextOptions: [],
            notificationStatusOptions: [],
        },
    });

    const getMemberProfile = async () => {
        try {
            const resp = await getMemberProfileApi(memberID);
            if (resp) {
                dispatch({ type: SET_MEMBER_PROFILE, payload: resp });
            }
        } catch (error) {
            console.error('獲取會員資料失敗:', error);
        }
    };

    const updateMeasureDay = (measureDayState = {}) => {
        dispatch({ type: UPDATE_MEASURE_DAY, payload: measureDayState });
    };

    const updateSMSStatus = (hasSMS = false) => {
        dispatch({ type: UPDATE_SMS_STATUS, payload: hasSMS });
    };

    const updateMarketingStatus = (hasMarketing = false) => {
        dispatch({ type: UPDATE_MARKETING_STATUS, payload: hasMarketing });
    }

    const updateProteinPush = (proteinPush = {}) => {
        dispatch({ type: UPDATE_PROTEIN_PUSH, payload: proteinPush });
    };

    const updateProbioticsPush = (probioticsPush = {}) => {
        dispatch({ type: UPDATE_PROBIOTICS_PUSH, payload: probioticsPush });
    };

    const updateSmartRingPush = (smartRingPush = {}) => {
        dispatch({ type: UPDATE_SMART_RING_PUSH, payload: smartRingPush });
    }

    const updateCalciumPush = (calciumPush = {}) => {
        dispatch({ type: UPDATE_CALCIUM_PUSH, payload: calciumPush });
    };

    const updateHundredTShirtSize = (hundredTShirtSize = '') => {
        dispatch({ type: UPDATE_HUNDRED_T_SHIRT_SIZE, payload: hundredTShirtSize });
    };

    const updateSpecialCondition = (specialCondition = '') => {
        dispatch({ type: UPDATE_SPECIAL_CONDITION, payload: specialCondition });
    };

    const updateMemo = (memo = '') => {
        dispatch({ type: UPDATE_MEMO, payload: memo });
    };

    const updateBatchPaymentMemo = (batchPaymentMemo = '') => {
        dispatch({ type: UPDATE_BATCH_PAYMENT_MEMO, payload: batchPaymentMemo });
    };

    const updateXFactorNotes = (xFactorNotes = []) => {
        dispatch({ type: UPDATE_X_FACTOR_NOTES, payload: xFactorNotes });
    };

    const updateAgreedNotes = (agreedNotes = []) => {
        dispatch({ type: UPDATE_AGREED_NOTES, payload: agreedNotes });
    };

    const updateGuidanceNotes = (guidanceNotes = '') => {
        dispatch({ type: UPDATE_GUIDANCE_NOTES, payload: guidanceNotes });
    };

    const updateSpecialBodyCondition = (specialBodyCondition = '') => {
        dispatch({ type: UPDATE_SPECIAL_BODY_CONDITION, payload: specialBodyCondition });
    };

    const updateServiceTasks = (serviceTasks = []) => {
        dispatch({ type: UPDATE_SERVICE_TASKS, payload: serviceTasks });
    };

    const updateDiscardRecordReason = (discardRecordReason = '') => {
        dispatch({ type: UPDATE_DISCARD_RECORD_REASON, payload: discardRecordReason });
    }

    useEffect(
        () => {
            if (isFetchOnMount && memberID) getMemberProfile();
        },
        // eslint-disable-next-line
        [isFetchOnMount],
    );

    return {
        memberProfile: state,
        dispatchMemberProfile: dispatch,
        getMemberProfile,
        updateMeasureDay,
        updateSMSStatus,
        updateMarketingStatus,
        updateProteinPush,
        updateProbioticsPush,
        updateSmartRingPush,
        updateCalciumPush,
        updateHundredTShirtSize,
        updateSpecialCondition,
        updateMemo,
        updateBatchPaymentMemo,
        updateXFactorNotes,
        updateAgreedNotes,
        updateGuidanceNotes,
        updateSpecialBodyCondition,
        updateServiceTasks,
        updateDiscardRecordReason,
    };
};

export default useGetMemberProfileState;
